module.exports = __webpack_public_path__ + "img/img5.585e86ca.svg";